// extracted by mini-css-extract-plugin
module.exports = {"root":"diji-blog-text-wrap_root__iwnVO","noPadding":"diji-blog-text-wrap_noPadding__Texw8","dark":"diji-blog-text-wrap_dark__4dMZA"};